import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';
import { categories, categoryMap } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = categoryMap[slug || ''] || '未知分类';
  const categoryDesc = categories.find((c) => c.slug === slug)?.desc || '';

  const filteredArticles = articles.filter((a) => a.category === slug);

  const seoData = {
    title: `${categoryName} - 黑料在线`,
    description: `黑料在线${categoryName}频道，为您提供最新${categoryName}爆料资讯。${categoryDesc}`,
    keywords: `${categoryName},黑料在线,${categoryName}爆料,${categoryName}内幕,${categoryName}黑料`,
    canonical: `https://heiliao-online.com/category/${slug}`,
  };

  return (
    <>
      <ScrollToTop />
      <head>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        <link rel="canonical" href={seoData.canonical} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoData.canonical} />
        <meta property="og:site_name" content="黑料在线" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.title} />
        <meta name="twitter:description" content={seoData.description} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": seoData.title,
            "description": seoData.description,
            "url": seoData.canonical,
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "黑料在线",
              "url": "https://heiliao-online.com"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://heiliao-online.com" },
              { "@type": "ListItem", "position": 2, "name": categoryName }
            ]
          })}
        </script>
      </head>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: categoryName },
              ]}
            />
          </div>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-1.5 h-7 bg-foreground-950 rounded-full"></div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap">
                {categoryName}
              </h1>
            </div>
            <p className="text-foreground-500 ml-5">{categoryDesc}</p>
          </section>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 mb-6">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-sm text-foreground-500 whitespace-nowrap">分类导航：</span>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    cat.slug === slug
                      ? 'bg-foreground-950 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200/70 hover:text-foreground-950'
                  }`}
                >
                  <i className={`${cat.icon} mr-1`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </section>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 pb-16">
            {filteredArticles.length > 0 ? (
              <>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
                  {filteredArticles.length > 0 && (
                    <div className="lg:col-span-2">
                      <ArticleCard article={filteredArticles[0]} variant="large" />
                    </div>
                  )}
                  <div className="flex flex-col gap-4">
                    {filteredArticles.slice(1, 4).map((article) => (
                      <ArticleCard key={article.slug} article={article} variant="compact" />
                    ))}
                  </div>
                </div>

                {filteredArticles.length > 4 && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {filteredArticles.slice(4).map((article) => (
                      <ArticleCard key={article.slug} article={article} variant="default" />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-20 text-foreground-400">
                <i className="ri-inbox-line text-5xl mb-4 block"></i>
                <p className="text-lg">该分类暂无内容，敬请期待</p>
                <Link to="/" className="mt-4 inline-block text-sm text-foreground-950 underline">
                  返回首页
                </Link>
              </div>
            )}
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}